<div aria-busy="true" [class]="size">
  <nav class="toolbar flex flex-column gap-3 py-2 px-2">
    @for (width of toolbarItems; track $index) {
      <div class="flex align-items-center gap-3 toolbar-item">
        <p-skeleton shape="circle" size="2.75rem" />
        @if (size === 'smaller') {
          <p-skeleton [width]="width + 'rem'" height="0.9rem" />
        }
      </div>
    }
  </nav>

  <header class="top-bar p-card flex align-items-center gap-2 pr-2 pl-3">
    <p-skeleton width="4rem" height="3rem" borderRadius="0.75rem" />
    <p-skeleton width="16rem" height="1.6rem" styleClass="max-w-full" />
    <p-skeleton
      class="hidden md:block ml-auto"
      width="14rem"
      height="2.4rem"
      borderRadius="2rem" />
    <div class="flex align-items-center gap-2 ml-auto md:ml-0">
      @for (button of topBarButtons; track button) {
        <p-skeleton shape="circle" size="2.4rem" />
      }
      <p-skeleton shape="circle" size="3rem" />
    </div>
  </header>

  <div class="content mt-7 pt-3 px-2 pb-6">
    <div class="grid">
      <div class="col-6 flex flex-column">
        <div class="flex align-items-center gap-3 px-2 pb-2">
          <p-skeleton width="5rem" height="1.1rem" />
          <p-skeleton width="6rem" height="1.1rem" />
          <p-skeleton class="ml-auto" shape="circle" size="2rem" />
          <p-skeleton width="8rem" height="2.4rem" borderRadius="2rem" />
        </div>
        <div class="p-card p-3 flex flex-column gap-4 flex-grow-1 levels">
          @for (level of levels; track $index) {
            <div class="flex flex-column gap-3">
              <div class="flex align-items-center gap-2">
                <p-skeleton size="1rem" />
                <p-skeleton [width]="level.title + 'rem'" height="1rem" />
                <p-skeleton class="ml-auto" shape="circle" size="1.5rem" />
              </div>
              <div class="flex flex-wrap gap-2">
                @for (chip of level.chips; track chip) {
                  <p-skeleton
                    width="5.5rem"
                    height="2.4rem"
                    borderRadius="2rem" />
                }
                <p-skeleton shape="circle" size="2.4rem" />
              </div>
            </div>
          }
        </div>
      </div>

      <div class="col-6">
        <p-skeleton width="100%" height="100%" borderRadius="10px" />
      </div>
    </div>

    @if (showIndicators) {
      <div class="grid">
        <div class="col-6">
          <div class="p-card p-3 flex flex-column gap-3">
            <div class="flex align-items-center gap-3">
              <p-skeleton shape="circle" size="1.25rem" />
              <p-skeleton width="11rem" height="1.25rem" />
            </div>
            <p-skeleton width="85%" height="0.9rem" />
            <div class="flex flex-wrap gap-3 pt-3">
              <p-skeleton width="12rem" height="2.6rem" borderRadius="2rem" />
              <p-skeleton width="13rem" height="2.6rem" borderRadius="2rem" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="p-card p-3 flex flex-column gap-3">
            <div class="flex align-items-center gap-3">
              <p-skeleton shape="circle" size="1.25rem" />
              <p-skeleton width="10rem" height="1.25rem" />
            </div>
            <p-skeleton width="95%" height="0.9rem" />
            <p-skeleton width="50%" height="0.9rem" />
          </div>
        </div>
      </div>
    }
  </div>
</div>
